import React from "react";
import pdfFile from "../pdfs/Tipkit-OnboardingYourTeam.pdf";
import PdfViewer from "../comman/PdfViewer";
import { onboardingDocs } from "../consfig";

const OnboardingTeam = () => {
  const pdfUrl = onboardingDocs.b2c.onBoardTeam;
  return <PdfViewer pdfFile={pdfUrl} />;
};
export default OnboardingTeam;
